
import RefreshRightSquare from "../../../assets/filled/RefreshRightSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RefreshRightSquareIcon({ className, dataTestid = "RefreshRightSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RefreshRightSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
